<template>
  <div>
    <!-- 登录/注册区域 -->
    <div v-if="isLoginRegister" id="bg_box" class="content">
      <div class="form form-margin">
        <div class="form-content">
          <!-- 登录/注册切换 -->
          <div class="form-title overflow">
            <div class="float-left comment-margin-right-middle">
              <div
                :class="isActive ? 'active' : 'no-active'"
                @click="switchTab('login')"
              >
                用户登录
              </div>
            </div>
            <div class="float-left">
              <div
                :class="isActive ? 'no-active' : 'active'"
                @click="switchTab('register')"
              >
                立即注册
              </div>
            </div>
          </div>

          <!-- 登录表单 -->
          <div v-if="isActive" class="login-form">
            <el-form :model="loginForm" ref="loginForm">
              <div class="input-border input-margin-bottom">
                <el-row>
                  <el-col :span="1">
                    <img src="../assets/img/phone.png" alt="" class="input-img" />
                  </el-col>
                  <el-col :span="19" :offset="2">
                    <el-form-item
                      prop="username"
                      :rules="[{ required: true, message: '请输入账号', trigger: 'change' }]"
                    >
                      <el-input
                        v-model="loginForm.username"
                        placeholder="请输入账号"
                        clearable
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="input-border">
                <el-row>
                  <el-col :span="1">
                    <img src="../assets/img/pwd.png" alt="" class="input-img" />
                  </el-col>
                  <el-col :span="19" :offset="2">
                    <el-form-item
                      prop="password"
                      :rules="[{ required: true, message: '请输入密码', trigger: 'change' }]"
                    >
                      <el-input
                        v-model="loginForm.password"
                        placeholder="请输入密码"
                        show-password
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div class="radio-group">
                <el-radio-group v-model="loginForm.role">
                  <el-radio label="tea">我是老师</el-radio>
                  <el-radio label="expert">我是专家</el-radio>
                  <el-radio label="gov">我是行政部门</el-radio>
                </el-radio-group>
              </div>
            </el-form>
            <div class="login-form-footer overflow">
              <div class="float-left forget-pwd" @click="handleForgetPwd">忘记密码？</div>
              <div class="float-right">
                <el-button
                  type="primary"
                  class="btn-primary login-btn"
                  :loading="btnLogin"
                  @click="login('loginForm')"
                >
                  立即登录
                </el-button>
              </div>
            </div>
          </div>

          <!-- 注册表单 -->
          <div v-else class="register">
            <el-form :model="registerForm" ref="registerForm">
              <div class="input-border">
                <el-row>
                  <el-col :span="1">
                    <img src="../assets/img/phone.png" alt="" class="input-img" />
                  </el-col>
                  <el-col :span="19" :offset="2">
                    <el-form-item
                      prop="username"
                      :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]"
                    >
                      <el-input
                        v-model="registerForm.username"
                        placeholder="请输入账号"
                        clearable
                        maxlength="11"
                        show-word-limit
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <el-row>
                  <el-col :span="16">
                    <el-row class="input-border">
                      <el-col :span="2">
                        <img src="../assets/img/baohu.png" alt="" class="input-img" />
                      </el-col>
                      <el-col :span="17" :offset="3">
                        <el-form-item
                          prop="code"
                          :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]"
                        >
                          <el-input
                            v-model="registerForm.code"
                            placeholder="请输入验证码"
                            clearable
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" :offset="1">
                    <el-button
                      class="getCode"
                      :disabled="registerGetCodeDisabled"
                      @click="getRegisterCode"
                    >
                      {{ registerGetCodeText }}
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <div class="input-border">
                <el-row>
                  <el-col :span="1">
                    <img src="../assets/img/pwd.png" alt="" class="input-img" />
                  </el-col>
                  <el-col :span="19" :offset="2">
                    <el-form-item
                      prop="password"
                      :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
                    >
                      <el-input
                        v-model="registerForm.password"
                        placeholder="请输入密码"
                        show-password
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-form-item
                prop="gender"
                :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
              >
                <div
                  :class="registerForm.gender == '1' ? 'register-gender-active float-left' : 'register-gender-null float-left'"
                  @click="switchGender('1')"
                >
                  男
                </div>
                <div
                  :class="registerForm.gender == '2' ? 'register-gender-active float-right' : 'register-gender-null float-right'"
                  @click="switchGender('2')"
                >
                  女
                </div>
              </el-form-item>
            </el-form>
            <div class="login-form-footer overflow">
              <div class="float-left forget-pwd" @click="handleForgetPwd">忘记密码？</div>
              <div class="float-right">
                <el-button
                  type="primary"
                  class="btn-primary login-btn"
                  :loading="btnLogin"
                  @click="register('registerForm')"
                >
                  立即注册
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-img-box">
        <img
          v-if="boxBgUrl"
          :src="boxBgUrl"
          class="bg-img"
          alt=""
        />
      </div>
    </div>

    <!-- 忘记密码区域 -->
    <div v-else class="forget-pwd-content">
      <div class="forget-pwd-content-edit" @click="handleBackToLogin">
        <span><img src="../assets/img/no-edit.png" /></span>
        <span>返回</span>
      </div>
      <div class="forget-pwd-container">
        <div class="forget-pwd-title">忘记密码</div>
        <div class="forget-pwd-form">
          <el-form :model="forgetPwdForm" ref="forgetPwdForm">
            <div class="input-border forget-pwd-content-buttom">
              <el-row>
                <el-col :span="1">
                  <img src="../assets/img/phone.png" alt="" class="input-img" />
                </el-col>
                <el-col :span="19" :offset="2">
                  <el-form-item
                    prop="phone"
                    :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }]"
                  >
                    <el-input
                      v-model="forgetPwdForm.phone"
                      placeholder="请输入手机号"
                      clearable
                      maxlength="11"
                      show-word-limit
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div>
              <el-row>
                <el-col :span="17">
                  <el-row class="input-border forget-pwd-content-buttom">
                    <el-col :span="1">
                      <img src="../assets/img/baohu.png" alt="" class="input-img" />
                    </el-col>
                    <el-col :span="19" :offset="3">
                      <el-form-item
                        prop="code"
                        :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]"
                      >
                        <el-input
                          v-model="forgetPwdForm.code"
                          placeholder="请输入验证码"
                          autocomplete="off"
                          clearable
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-button
                    class="getCode"
                    :disabled="resetGetCodeDisabled"
                    @click="getResetCode"
                  >
                    {{ resetGetCodeText }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
            <div class="input-border forget-pwd-content-buttom">
              <el-row>
                <el-col :span="1">
                  <img src="../assets/img/pwd.png" alt="" class="input-img" />
                </el-col>
                <el-col :span="19" :offset="2">
                  <el-form-item
                    prop="password"
                    :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
                  >
                    <el-input
                      v-model="forgetPwdForm.password"
                      placeholder="请输入密码"
                      autocomplete="off"
                      clearable
                      show-password
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="input-border forget-pwd-content-buttom">
              <el-row>
                <el-col :span="1">
                  <img src="../assets/img/pwd.png" alt="" class="input-img" />
                </el-col>
                <el-col :span="19" :offset="2">
                  <el-form-item
                    prop="checkPass"
                    :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
                  >
                    <el-input
                      v-model="forgetPwdForm.checkPass"
                      placeholder="请再此输入密码"
                      clearable
                      show-password
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
          <div class="forget-pwd-form-btn">
            <el-button
              type="primary"
              class="btn-primary login-btn"
              :loading="btnLogin"
              @click="resetPwd('forgetPwdForm')"
            >
              立即重置
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      isLoginRegister: true, // 是否显示登录/注册区域
      isActive: true, // 登录/注册tab切换
      loginForm: {
        username: "",
        password: "",
        role: "tea",
      },
      registerForm: {
        username: "",
        password: "",
        code: "",
        gender: "1",
      },
      registerGetCodeText: "获取验证码",
      registerGetCodeDisabled: false,
      forgetPwdForm: {
        phone: "",
        password: "",
        checkPass: "",
        code: "",
      },
      resetGetCodeText: "获取验证码",
      resetGetCodeDisabled: false,
      btnLogin: false,
      boxBgUrl: "",
    };
  },
  mounted() {
    // 监听回车事件
    document.onkeydown = (e) => {
      if (e.keyCode === 13) {
        if (this.isLoginRegister) {
          this.isActive ? this.login("loginForm") : this.register("registerForm");
        } else {
          this.resetPwd("forgetPwdForm");
        }
      }
    };
    let timer = setInterval(() => {
      const theme = JSON.parse(sessionStorage.getItem("competition_course_detail"))?.config?.theme?.organization || null;
      if (theme) {
        this.boxBgUrl = this.alOssUrl + theme.login_show_image;
        clearInterval(timer);
      }
    }, 50);
  },
  methods: {
    // tab切换
    switchTab(type) {
      this.isActive = type === "login";
    },
    // 忘记密码
    handleForgetPwd() {
      this.isLoginRegister = false;
    },
    // 忘记密码-返回
    handleBackToLogin() {
      this.isLoginRegister = true;
    },
    // 登录
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        const obj = {
          username: this.loginForm.username,
          password: this.loginForm.password,
          role: this.loginForm.role,
        };
        this.btnLogin = true;
        this.HttpUtil.Post(this.api.util.authLogin, obj, {
          competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
        }, {
          split_loginRole: true
        }).then(res => {
          // 获取自定义的字段
          this.getFieldList().then(() => {
            this.btnLogin = false;
            this.$message.success('登录成功！')
            this.$store.dispatch("loginState", true);
            sessionStorage.setItem("userInfo", JSON.stringify(res.info));
            sessionStorage.setItem("token", res.token);
            switch (this.loginForm.role) {
              case 'tea':
                sessionStorage.setItem("loginRole", 'staff');
                this.$router.push({ name: "index" });
                break;
              case 'gov':
                sessionStorage.setItem("loginRole", 'government');
                this.$router.push({ name: "govermentList" });
                break;
              case 'expert':
                sessionStorage.setItem("loginRole", 'competition_course_expert');
                this.$router.push({ name: "index" });
                break;
            }
            // 禁止登录后通过浏览器返回
            history.pushState(null, null, document.URL);
            window.addEventListener("popstate", function () {
              history.pushState(null, null, document.URL);
            }, false);
          })
        }).finally(() => {
          this.btnLogin = false;
        })
      });
    },
    // 获取自定义的字段
    getFieldList() {
      return new Promise((resolve, reject) => {
        this.HttpUtil.Get(this.api.util.competitionCourseFieldList, {
          competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id'),
          limit: 0,
        }, {
          split_loginRole: true,
        }).then(res => {
          sessionStorage.setItem('fieldOptions', JSON.stringify(res.list))
          resolve(res.list)
        })
      })
    },
    // 注册
    register(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        const pwdRegex = new RegExp(this.util.reg.regPwd);
        if (!pwdRegex.test(this.registerForm.password)) {
          this.$message({
            message: this.util.reg.regPwdMsg,
            type: "error",
          });
          return;
        }
        const obj = {
          phone: this.registerForm.username,
          code: this.registerForm.code,
          password: this.registerForm.password,
          gender: this.registerForm.gender,
        };
        this.btnLogin = true;
        this.HttpUtil.Post(this.api.util.authRegister, obj, {}, {
          split_loginRole: true
        }).then(res => {
          this.btnLogin = false;
          this.$message.success('注册成功！')
          this.isActive = true;
        }).finally(() => {
          this.btnLogin = false;
        })
      });
    },
    // 注册获取验证码
    getRegisterCode() {
      if (!this.registerForm.username) {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.registerForm.username)) {
        this.$message({ message: "请填写正确的手机号!", type: "error" });
        return;
      }
      this.HttpUtil.Post(this.api.common.smsCaptcha, {
        phone: this.registerForm.username
      }, {}, {}, {
        // skipInterceptors: true
        commonApi: true
      }).then(res => {
        this.$message({ message: "验证码发送成功！", type: "success" });
          sessionStorage.setItem("signature", JSON.stringify(res.signature));
      })
      // 60S倒计时
      this.registerGetCodeText = 60;
      this.registerGetCodeDisabled = true;
      let timer = setInterval(() => {
        this.registerGetCodeText--;
        if (
          this.registerGetCodeText === 0 ||
          !this.isLoginRegister ||
          this.isActive
        ) {
          this.registerGetCodeText = "获取验证码";
          this.registerGetCodeDisabled = false;
          clearInterval(timer);
        }
      }, 1000);
    },
    // 注册切换性别
    switchGender(type) {
      this.registerForm.gender = type;
    },
    // 重置密码
    resetPwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if (this.forgetPwdForm.checkPass !== this.forgetPwdForm.password) {
          this.$message.error("两次密码不一致！");
          return;
        }
        const pwdRegex = new RegExp(this.util.reg.regPwd);
        if (!pwdRegex.test(this.forgetPwdForm.checkPass)) {
          this.$message({
            message: this.util.reg.regPwdMsg,
            type: "error",
          });
          return;
        }
        const obj = {
          phone: this.forgetPwdForm.phone,
          code: this.forgetPwdForm.code,
          password: this.forgetPwdForm.checkPass,
        };
        this.btnLogin = true;
        this.HttpUtil.Post(this.api.util.authForgetPassword, obj, {}, {
          split_loginRole: true
        }).then(res => {
          this.btnLogin = false;
          this.$message.success('密码重置成功！')
          this.isLoginRegister = true;
          this.isActive = true;
        }).finally(() => {
          this.btnLogin = false;
        })
      });
    },
    // 忘记密码获取验证码
    getResetCode() {
      if (!this.forgetPwdForm.phone) {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.forgetPwdForm.phone)) {
        this.$message({ message: "请填写正确的手机号!", type: "error" });
        return;
      }
      this.HttpUtil.Get(this.api.util.authIsRegistered, {
        phone: this.forgetPwdForm.phone
      }, {
        split_loginRole: true
      }).then(res => {
        if (!res.is_registered) {
          this.$message.error("该账号未注册！")
        } else {
          this.HttpUtil.Post(this.api.common.smsCaptcha, {
            phone: this.forgetPwdForm.phone
          }, {}, {}, {
            // skipInterceptors: true
            commonApi: true
          }).then(res => {
            this.$message.success("验证码发送成功！")
            sessionStorage.setItem("signature", JSON.stringify(res.signature))
          })
          // 60S倒计时
          this.resetGetCodeText = 60;
          this.resetGetCodeDisabled = true;
          let timer = setInterval(() => {
            this.resetGetCodeText--;
            if (this.resetGetCodeText === 0) {
              this.resetGetCodeText = "获取验证码";
              this.resetGetCodeDisabled = false;
              clearInterval(timer);
            }
          }, 1000);
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      sessionStorage.setItem('competition_course_poster_id', to.query.id)
    }
    if (to.query.province_name) {
      sessionStorage.setItem('province_name', to.query.province_name)
    }
    next()
  },
  watch: {
    isActive(val) {
      this.loginForm.username = "";
      this.loginForm.password = "";
      this.loginForm.role = "tea";
      this.registerForm.username = "";
      this.registerForm.password = "";
      this.registerForm.code = "";
      this.$nextTick(() => {
        if (val) {
          this.$refs["loginForm"].resetFields();
        } else {
          this.$refs["registerForm"].resetFields();
        }
      });
    },
    isLoginRegister() {
      this.forgetPwdForm.phone = "";
      this.forgetPwdForm.password = "";
      this.forgetPwdForm.checkPass = "";
      this.forgetPwdForm.code = "";
    },
  },
};
</script>

<style scoped>
.content {
  width: 68%;
  height: 600px;
  min-height: 600px;
  min-width: 1100px;
  margin: 0 auto;
  background-color: #fff;
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
  box-sizing: border-box;
  border-radius: 12px;
}
#bg_box {
  display: flex;
  justify-content: space-between;
}
.bg-img-box {
  max-width: 600px;
  height: 100%;
  border-radius: 0 12px 12px 0;
  overflow: hidden;
}
.bg-img {
  width: 100%;
  height: 100%;
}
.form-content {
  width: 22vw;
  min-width: 400px;
}
.form-title > div {
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  cursor: pointer;
  margin-bottom: 60px;
}
.no-active {
  color: #ccc;
  height: 45px;
  border-bottom: 4px solid #ccc;
}
.active {
  color: #ff3b3d;
  height: 45px;
  border-bottom: 4px solid #ff3b3d;
}
.input-border /deep/ .el-input__inner {
  border: none;
  height: 45px;
  min-height: 45px;
  line-height: 60px;
}
.input-border .input-img {
  width: 30px !important;
  height: 30px !important;
}
.login-form-footer {
  margin-top: 50px;
}

.login-btn {
  background: #ff3b3d;
  border-radius: 5px !important;
}
.forget-pwd {
  height: 50px;
  display: table-cell;
  vertical-align: middle;
  padding-top: 10px;
  box-sizing: border-box;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ccc;
  cursor: pointer;
}
.forget-pwd-content {
  width: 600px;
  height: 600px;
  margin: 0 auto;
  padding: 1vw 1.5vw;
  box-sizing: border-box;
  background: #fffefd;
  background-image: none !important;
  border-radius: 12px;
  margin-top: 10vh;
}
.forget-pwd-content-buttom {
  margin-bottom: 40px;
}
.forget-pwd-container {
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;
}
.forget-pwd-title {
  width: 115px;
  height: 45px;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ff3b3d;
  border-bottom: 4px solid #ff3b3d;
}
.forget-pwd-form {
  margin-top: 40px;
}
.forget-pwd-form-btn {
  text-align: center;
}
.forget-pwd-content-edit {
  color: #333;
  cursor: pointer;
  font-size: 20px;
}
.forget-pwd-content-edit span {
  margin-right: 10px;
}
.getCode {
  width: 130px;
  height: 45px;
  background: #fff;
  box-shadow: 0px 3px 5px 0px rgba(255, 59, 61, 0.15),
    0px -5px 5px 0px rgba(255, 59, 61, 0.05);
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  color: #ff3b3d;
  margin-right: 20px;
  border: none;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
.content /deep/ .el-form-item__error,
.forget-pwd-content /deep/ .el-form-item__error {
  padding-top: 10px;
  padding-left: 15px;
}
.register-gender-active {
  width: 48%;
  height: 45px;
  background: #ffbd59;
  box-shadow: 0px 3px 5px 0px rgba(255, 59, 61, 0.15),
    0px -5px 5px 0px rgba(255, 59, 61, 0.05);
  border-radius: 25px;
  text-align: center;
  line-height: 45px;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
}
.register-gender-null {
  width: 48%;
  height: 45px;
  background: #fff;
  box-shadow: 0px 3px 5px 0px rgba(255, 59, 61, 0.15),
    0px -5px 5px 0px rgba(255, 59, 61, 0.05);
  border-radius: 25px;
  text-align: center;
  line-height: 45px;
  color: #777;
  cursor: pointer;
  font-weight: bold;
}
.comment-margin-right-middle {
  margin-right: 40px;
}
.form-margin {
  margin-top: 5vw;
  margin-left: 3vw;
}
.input-margin-bottom {
  margin-bottom: 60px;
}
</style>
